import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'

import { cn } from '#/shared/lib/utils'
import {
  CheckboxCheckedIcon,
  RadioSelectedIcon,
  RadioUnselectedIcon,
} from '#/shared/ui/icons'

type CheckboxProps = React.ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
>

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, ...props }, ref) => {
  const isIndeterminate = props.checked === 'indeterminate'
  const isChecked = props.checked === true
  const isActive = isIndeterminate || isChecked

  const Icon = isIndeterminate
    ? RadioSelectedIcon
    : isChecked
      ? CheckboxCheckedIcon
      : RadioUnselectedIcon

  const colorClass = isActive ? 'text-primary' : 'text-gray-200'

  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        'inline-flex size-5 shrink-0 cursor-pointer items-center justify-center bg-transparent focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        colorClass,
        className,
      )}
      {...props}
    >
      <Icon className="size-5" />
    </CheckboxPrimitive.Root>
  )
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
